module.exports = __webpack_public_path__ + "img/iuridiuli.ee825627.png";